module.exports = __webpack_public_path__ + "img/aprendizaje.5a0edca8.png";